import { useState } from "react";
import { useDispatch } from "react-redux";
import { setLocation as setLocationAction } from "../Redux/slices/locationSlice";

const useUserLocation = () => {
  const [location, setLocationState] = useState({
    city: "New Delhi",
    state: "Delhi",
    locality: "", // Added locality
    locationAllowed: false,
  });
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const updateReduxLocation = (newLocation) => {
    setLocationState(newLocation);
    // dispatch(setLocationAction(newLocation)); // Update Redux store
  };

  const fetchLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          fetchCityFromCoordinates(latitude, longitude);
        },
        () => {
          setError("Location access denied! Using default location: New Delhi.");
          updateReduxLocation({
            city: "New Delhi",
            state: "Delhi",
            locality: "",
            locationAllowed: false,
          });
        }
      );
    } else {
      setError("Geolocation is not supported by your browser.");
      updateReduxLocation({
        city: "New Delhi",
        state: "Delhi",
        locality: "",
        locationAllowed: false,
      });
    }
  };

  const fetchCityFromCoordinates = async (latitude, longitude) => {
    const apiKey = "9ef24ca8d8a4474aa142847bf3c1ce4e"; // OpenCage API Key
    const apiUrl = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;

    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      console.log("dadaddata",data)
      if (data && data.results && data.results.length > 0) {
        const locationDetails = data.results[0].components;
        const updatedLocation = {
          city: locationDetails.city || locationDetails.town || "New Delhi",
          state: locationDetails.state || "Unknown",
          locality: locationDetails.suburb || locationDetails.neighbourhood || "Unknown", // Fetch locality
          locationAllowed: true,
        };
        updateReduxLocation(updatedLocation);
        setError("");
      } else {
        setError("Unable to fetch location details. Using default location.");
        updateReduxLocation({
          city: "New Delhi",
          state: "Delhi",
          locality: "",
          locationAllowed: false,
        });
      }
    } catch (err) {
      setError("Error fetching location details. Using default location.");
      updateReduxLocation({
        city: "New Delhi",
        state: "Delhi",
        locality: "",
        locationAllowed: false,
      });
    }
  };

  return { location, error, fetchLocation };
};

export default useUserLocation;
